export const DESIGNS_BUCKET = 'designs'
export const DEFAULT_DESIGNS_LIMITS = [10, 25, 50]
export const EMPTY_FIELD = 'The field cannot be left empty.'
export const INCH_TO_MM = 25.4
export const INCHES_UNIT = 'in'
export const INVALID_FIELD = 'Please enter a valid value.'
export const MILLIMETER_UNIT = 'mm'
export const MODELS_PER_PAGE_LIMIT = 50
